import { Controller } from "react-hook-form"
import { Factory, Utensils } from "lucide-react"

import { Label } from "@/components/ui/label"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"

import type { ProductFieldGroupProps } from "./product-field-types"

export function ConsumptionTypeField({ control, labels }: ProductFieldGroupProps) {
  return (
    <div className="col-span-1 space-y-4 pt-4 md:col-span-2">
      <Label className="label-industrial">{labels.consumptionType}</Label>
      <Controller
        name="consumptionType"
        control={control}
        render={({ field }) => (
          <RadioGroup
            onValueChange={field.onChange}
            defaultValue={field.value}
            value={field.value}
            className="grid grid-cols-1 gap-4 sm:grid-cols-2"
          >
            <div className="relative">
              <RadioGroupItem value="Human" id="human" className="peer sr-only" />
              <Label
                htmlFor="human"
                className="flex cursor-pointer items-center gap-3 rounded-lg border-2 border-muted bg-popover px-4 py-3 hover:bg-accent peer-data-[state=checked]:border-primary peer-data-[state=checked]:bg-primary/5 [&:has([data-state=checked])]:border-primary"
              >
                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <Utensils className="h-4 w-4" />
                </div>
                <span className="text-sm font-bold uppercase tracking-wider">
                  {labels.consumptionHuman}
                </span>
              </Label>
            </div>

            <div className="relative">
              <RadioGroupItem value="Industrial" id="industrial" className="peer sr-only" />
              <Label
                htmlFor="industrial"
                className="flex cursor-pointer items-center gap-3 rounded-lg border-2 border-muted bg-popover px-4 py-3 hover:bg-accent peer-data-[state=checked]:border-primary peer-data-[state=checked]:bg-primary/5 [&:has([data-state=checked])]:border-primary"
              >
                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent/10 text-accent">
                  <Factory className="h-4 w-4" />
                </div>
                <span className="text-sm font-bold uppercase tracking-wider">
                  {labels.consumptionIndustrial}
                </span>
              </Label>
            </div>
          </RadioGroup>
        )}
      />
    </div>
  )
}
